// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"dec4c112","1172":"c44b15c8","1796":"f9500a02","8678":"f9500a02"}[chunkId] + ".chunk.css";
};